import { render, staticRenderFns } from "./CommunitySubscriptions.vue?vue&type=template&id=4aa24862"
import script from "./CommunitySubscriptions.vue?vue&type=script&lang=js"
export * from "./CommunitySubscriptions.vue?vue&type=script&lang=js"
import style0 from "./CommunitySubscriptions.vue?vue&type=style&index=0&id=4aa24862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports